// ===================================
// Table of content
// -----------------------------------
// Variables
// Utilities
// 3. Footer nav item mobile
// 4. OnTrust icon click
// 5. Add attr target="_blank"
// 6. Call intercom
// 7. onloadScript
// 8. Menu dropdown
// 9. Search
// 10. nav menu
// 11. Hide sticky
// 12. TrustRadius slider
// ====================================



// ================
// Variables
// ================

var mq = {};
var hash = window.location.hash.slice(1);





// ================
// Utilities
// ================

function detectOS() {
  let userAgent = window.navigator.userAgent,
    platform = window.navigator.platform,
    macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
    windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
    iosPlatforms = ['iPhone', 'iPad', 'iPod'],
    os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows';
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
  } else if (!os && /Linux/.test(platform)) {
    os = 'Linux';
  }

  return os;
}

function addPreload(src, type) {
    var link = document.createElement('link');
    link.rel = 'preload';
    link.href = src;
    if (typeof type === "undefined") {
        type = 'style';
    }
    link.as = type;
    document.body.append(link);
}


function createMq(mqBreakpoints) {
    for (var i = 0; i < mqBreakpoints.length; i++) {
        var mqRange = i === 0 ? 'max' : 'min';

        mq[mqBreakpoints[i][0]] = {
            int: mqBreakpoints[i][1],
            str: '(' + mqRange + '-' + 'width: ' + mqBreakpoints[i][1] + 'px)'
        };
    }
}

createMq([
    ['sm', 769],
    ['md', 991],
    ['lg', 1171],
    ['lx', 1291]
]);


// ==========================
// 3. Footer nav item mobile
// ==========================

var menuFooterItem = $('.nav-site-footer__item .footer-menu-toggle');

menuFooterItem.click(function (e) {
    if (window.innerWidth <= 1023) {
        var _ = $(this);
        _.parent().toggleClass('is-active');
        _.parent().find('.nav-site-footer__submenu').slideToggle();
    }
});


// ==========================
// 4. OnTrust icon click
// ==========================

document.addEventListener('DOMContentLoaded', function () {
    let aFooterElementOnTrust = document.querySelector('a.ot-sdk-show-settings')
    let svgOnTrustFooter = document.getElementById('onTrustIcon')
    
    svgOnTrustFooter.addEventListener('click', function () {
        aFooterElementOnTrust.click()
    })
})



// ==============================
// 5. Add attr target="_blank"
// ==============================

var exceptDomain = location.host.match('(([a-z\-]+)(?:\.com|\.fr|\.co.uk))');

if (exceptDomain) exceptDomain = exceptDomain[0];
else exceptDomain = location.host;

var selector = 'a[href*="://"]:not([href*="' + exceptDomain + '/"])';
var links = document.querySelectorAll(selector);

links.forEach(link => {
    if (link.target != '_blank') link.setAttribute('target', '_blank');
    if (!(link.rel.indexOf('noopener') + 1 || link.rel.indexOf('noreferrer') + 1)) link.setAttribute('rel', 'noopener noreferrer');
});





// ==============================
// 6. Call intercom
// ==============================

var callIntercom = document.querySelectorAll('.call_intercom');

callIntercom.forEach(function (item) {
    item.onclick = function (e) {
        e.preventDefault();
        Intercom('showNewMessage');
    }
})





// ==================
// 7. onloadScript
// ==================

if (typeof queueMarketo === 'function') {
    queueMarketo(function () {
        if (document.querySelector('[id^=mktoForm_]')) {

            MktoForms2.whenReady(function (form) {

                if (document.getElementById('autofillform')) {
                    form.setValues(JSON.parse(localStorage.getItem('formStorage')))
                }


                // ----------------------
                // Hide popup form
                // and show popup thank
                // ----------------------

                form.onSuccess(function () {
                    var email = $('input[type=email]').val();
                    var expires = new Date();
                    document.cookie = "atk_signup=" + btoa(email) + ";expires=" + expires.toUTCString() + ";domain=.activtrak.com;path=/";

                    if (window.location.hash.slice(1) == 'subscription') {
                        history.pushState("", document.title, window.location.pathname);
                        modalSubscribe.addClass('is-active');
                        $('.popup-subscribe').addClass('is-active');

                        if ($('.modal-subscribe') && $('.modal-subscribe').hasClass('is-active')) {
                            history.pushState("", document.title, window.location.pathname);
                            $('.modal-subscribe').removeClass('is-active')
                        }

                        return false;
                    }

                    if ($('.blog_post') || $('.blog')) {
                        $('.newsletter').removeClass('is-active');
                        Cookie.set('showNewsletter', false);
                        showNewsletter = Cookie.get('showNewsletter');
                        $('.popup-subscribe').addClass('is-active');
                        return false;
                    }
                });


                form.onSuccess(function () {
                    let formValue = form.getValues();
                    localStorage.setItem('formStorage', JSON.stringify(formValue))
                });


                // ------------------------
                // Validation email field
                // ------------------------

                $(".mktoButton").on("click", validate);

                function validateEmail(email) {
                    var re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
                    return re.test(String(email).toLowerCase());
                }

                function validate() {
                    var email = $(this.form).find('[name=Email]');
                    var tooltip = $(this.form).find(".tooltip");
                    var formInvalid = $(this.form).parent().find(".form__invalid");

                    if (validateEmail(email.val())) {
                        email.parent().removeClass('mktoInvalid');

                        if (tooltip) tooltip.hide(200);
                        if (formInvalid) formInvalid.hide(200);

                        return true;
                    } else {
                        email.parent().addClass('mktoInvalid');

                        if (tooltip) tooltip.show(200);
                        if (formInvalid) formInvalid.show(200);

                        return false;
                    }
                }
            });
        }
    });
}




// ===================
// 8. Menu dropdown
// ===================

var $menuDropdown = $('#menu-dropdown');
var $menuDropdownToggle = $('#menu-dropdown-toggle');

$menuDropdownToggle.on('click touchend', function () {
    $(this).toggleClass('is-active');
    $menuDropdown
        .stop(0)
        .fadeToggle(200);

    return false;
});





// ===================
// 9. Search
// ===================

document.getElementById('s').value = "";

$('.customer-utility-nav .is-search').click(function (e) {
    e.preventDefault();
    $('.site-search').toggleClass('is-active');
    $('.site-search input').focus();
});

$('.site-search__close').click(function (e) {
    e.preventDefault();
    $('.site-search ').removeClass('is-active');
    $('.site-search input').focusout();
});

document.onkeydown = function (evt) {
    evt = evt || window.event;
    var isEscape = false;
    if ("key" in evt) {
        isEscape = evt.key === "Escape" || evt.key === "Esc";
    } else {
        isEscape = evt.keyCode === 27;
    }
    if (isEscape) {
        $('.site-search ').removeClass('is-active');
    }
};





// ===============
// 10. nav menu
// ===============

var menuItem = $('.nav-list__item.is-combobox');

menuItem.click(function (e) {

    if (window.innerWidth <= 1023) {
        var _ = $(this);

        _.parent().toggleClass('is-active');
        _.find('.nav-list__submenu').slideToggle();
    }
});

menuItem.mouseover(function () {
    $('body').addClass('is-menu-active');
});

menuItem.mouseout(function () {
    $('body').removeClass('is-menu-active');
});





// ================
// 11. Hide sticky
// ================

$(document).ready(function () {
    var isBannerClosed = false;
    var buttonClose = $('.close-button-banner');

    $(window).on("scroll", function () {
        if (!isBannerClosed) {
            if ($(window).scrollTop() > 400) {
                $('.sticky-banner').addClass('is-active');
                buttonClose.css('display', 'block');
            } else {
                $('.sticky-banner').removeClass('is-active');
                buttonClose.css('display', 'none');
            }
        }
        checkStickyBanner();
    });

    $(document).on("click", ".close-button-banner", function () {
        $('.sticky-banner').removeClass('is-active');
        buttonClose.css('display', 'none');
        isBannerClosed = true;
        checkStickyBanner();
    });

    function checkStickyBanner() {
        if (!isBannerClosed && $('.sticky-banner').length) {
            $('body').css('padding-bottom', $('.sticky-banner').outerHeight());
        } else {
            $('body').css('padding-bottom', 0);
        }
    }

    checkStickyBanner();
    $(window).resize(checkStickyBanner);
});


// =======================
// 12. TrustRadius slider
// =======================

if (document.getElementsByClassName('trustradius-tqw').length > 0) {
    addPreload("//www.trustradius.com/trustquotes/style.css", "style");
    onloadScript("//www.trustradius.com/trustquotes/trustquotes.js", 0, function () {

        function updateSlide(delay = 0) {
            slide = $('.tr-card');

            setTimeout(function () {
                slide.each(function () {
                    if ($(this).css('visibility') == 'hidden') $(this).hide();else $(this).show();
                });
            }, delay);
        }

        var slide = void 0;
        var timerId = setInterval(function () {
            slide = $('.tr-card');

            if(detectOS().toLowerCase() === 'mac os') {
                $('.trustradius-tqw div.tr-fancy div.tr-actions a.tr-read-all-link').addClass('mac-os');
            }

            if (slide.length) {
                clearInterval(timerId);
                updateSlide(1000);

                $('.tr-right-navigation').click(function () {
                    updateSlide();
                });

                $('.tr-left-navigation').click(function () {
                    updateSlide();
                });
            }
        }, 500);
    });  
}

$(document).ready(function () {
    const copyLink = document.getElementById('copyLink');

    if (copyLink) {
        copyLink.addEventListener('click', function (event) {
            event.preventDefault();

            const urlToCopy = window.location.href;
            const textarea = document.createElement('textarea');
            textarea.value = urlToCopy;
            document.body.appendChild(textarea);
            textarea.select();

            document.execCommand('copy');
            document.body.removeChild(textarea);
        });
    }
});

// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
// =======================================================
// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=


























// ======================
// Table of contents
// ----------------------
// 1. UTILITIES
// 2. WISTIA
// =======================


// ===============
// 1. UTILITIES
// ===============



function _asyncToGenerator(fn) {
    return function () {
        var gen = fn.apply(this, arguments);
        return new Promise(function (resolve, reject) {
            function step(key, arg) {
                try {
                    var info = gen[key](arg);
                    var value = info.value;
                } catch (error) {
                    reject(error);
                    return;
                }
                if (info.done) {
                    resolve(value);
                } else {
                    return Promise.resolve(value).then(function (value) {
                        step("next", value);
                    }, function (err) {
                        step("throw", err);
                    });
                }
            }
            return step("next");
        });
    };
}

// ===============
// Popup form
// ===============

$('.js-form').click(function (e) {
    e.preventDefault();
    window.location.hash = 'modal-form';

    if (!$('html').hasClass('is-no-scroll')) {
        $('html').toggleClass('is-no-scroll');
    }

    $('.popup-form').toggleClass('is-active');
})

$('.popup-form__close').click(function (e) {
    function removeHash() {
        history.pushState("", document.title, window.location.pathname + window.location.search);
    }
    $('html').toggleClass('is-no-scroll');
    $('.popup-form').toggleClass('is-active');
    removeHash();
})



// ================
// popup for link
// ================

$(document).on('click', 'a', function (e) {
    if (!this.classList.contains('popup__btn') && ~this.href.indexOf("/") && $('.popup')[0]) {
        e.preventDefault();
        var link = this.href;
        disablePageScroll();
        $('.popup').addClass('is-active');
        $('.popup__close').click(function () {
            $('html').removeClass('is-no-scroll');
            $('.popup').hide();
            enablePageScroll();
            document.location = link;
        });
    }
});
















// =======================
// 2. WISTIA HEAP TRACKING
// =======================

if (document.querySelector('[class*="wistia_embed"]')) {

    var trackWistiaPlaysInHeap = function(video, percentage){
        if (typeof window.heap === 'undefined') {
            console.log("Heap undefined.");
            return;
        }
        var reportingObject = {
            nameOfVideo: video.name(),
            percentageReached: percentage,
            duration: (video.duration() / 60).toFixed(2) + ' minutes total'
        };

        window.heap.track("Wistia Video", reportingObject);
    };

    /*   Initialize all videos on the page to be handled by
    the Wistia integration */
    window._wq = window._wq || [];
    _wq.push({ '_all': function(video) {

        /* Define time markers in number of seconds */
        var quarterPlayed = Math.floor(video.duration() / 4),
        halfPlayed = Math.floor(video.duration() / 2),
        threeQuartersPlayed = quarterPlayed * 3;

        /*Track when a video is played */
        video.bind('play', function(){
            trackWistiaPlaysInHeap(video, 0);
        });

        /* Track quarters watched */
        video.bind('secondchange', function(s){
            if (s === quarterPlayed){
                trackWistiaPlaysInHeap(video, 0.25);
            }
            if (s === halfPlayed){
                trackWistiaPlaysInHeap(video, 0.5);
            }
            if (s === threeQuartersPlayed){
                trackWistiaPlaysInHeap(video, 0.75);
            }
        });

            /* Track videos finished */
            video.bind('end', function () {
                trackWistiaPlaysInHeap(video, 1);
            });

            // video.bind('pause', function () {
            //     console.log('paused');
            //     // $(document).find('script[src$="//fast.wistia.com/assets/external/E-v1.js"]').remove();
            // });
    }});
}


// =========================================
// Watch Now Hash - Init first video to play
// =========================================
if (hash == 'watch-now') {
    checkWistia(function() {
        // first wistia embed on a page
        var wistiaEmbed = document.querySelector('[class*="wistia_embed"]');
        if (typeof wistiaEmbed == 'object') {
            var wistiaVideoId = wistiaEmbed.classList[1].split('_')[2];
            window._wq = window._wq || [];
            _wq.push({ id: wistiaVideoId, onReady: function(video) {
                video.popover.show();
                video.play();
            }});
        }
    });
}